import * as t from 'ts-codec';
import { Product } from '../common';

export const OperationResponse = t.object({
  success: t.boolean
});
export type OperationResponse = t.Encoded<typeof OperationResponse>;

export const DoSignupVerificationParams = t.object({
  code: t.string
});
export type DoSignupVerificationParams = t.Encoded<typeof DoSignupVerificationParams>;

export const SendSignupVerificationParams = t.object({
  phone_number: t.string,
  token: t.string
});
export type SendSignupVerificationParams = t.Encoded<typeof SendSignupVerificationParams>;

export const ReCaptchaVerificationParams = t.object({
  recaptcha_token: t.string
});
export type ReCaptchaVerificationParams = t.Encoded<typeof ReCaptchaVerificationParams>;

export const StartEmailSignupRequest = t.object({
  email: t.string,
  recaptcha_token: t.string,
  recaptcha_version: t.string,
  product: t.Enum(Product),
  origin: t.string.optional(),
  cookie_id: t.string.optional()
});
export type StartEmailSignupRequest = t.Encoded<typeof StartEmailSignupRequest>;

export const StartEmailSignupResponse = t.object({
  success: t.boolean,
  fallback: t.boolean.optional()
});
export type StartEmailSignupResponse = t.Encoded<typeof StartEmailSignupResponse>;

export const ProvisionUserTokenResponse = t.object({
  token: t.string
});
export type ProvisionUserTokenResponse = t.Encoded<typeof ProvisionUserTokenResponse>;

export const SendMobileEmailParams = t.object({
  email: t.string,
  link: t.string,
  fullname: t.string.optional(),
  product: t.Enum(Product)
});
export type SendMobileEmailParams = t.Encoded<typeof SendMobileEmailParams>;

export const CompleteSignupParams = t.object({
  first_name: t.string,
  last_name: t.string,
  password: t.string,
  org_name: t.string.optional(),
  phone_number: t.string.optional(),
  id: t.string
});
export type CompleteSignupParams = t.Encoded<typeof CompleteSignupParams>;

export const CompleteSignupResponse = t.object({
  url: t.string
});
export type CompleteSignupResponse = t.Encoded<typeof CompleteSignupResponse>;

export const StartGithubSignupRequest = t.object({
  origin: t.string,
  product: t.Enum(Product),
  cookie_id: t.string
});
export type StartGithubSignupRequest = t.Encoded<typeof StartGithubSignupRequest>;
